import React from "react";
import { Pagination, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";


const TotalAssessedUsers = ({
  data,
  COLOR_MAP,
  getUserRiskKey,
  currentPage,
  totalRecords,
  onPageChange,
}) => {
  if (!data?.length) {
    return (
      <div style={{ textAlign: "center", color: "#f45858" }}>
        <h3>No Data </h3>
      </div>
    );
  }

  return (
    <>
      {data.map((user, index) => {
       let riskKey = "critical";
 
        if (user?.risk_score >= 750) {
          riskKey = "excellent";
        } else if (user?.risk_score >= 650) {
          riskKey = "good";
        } else if (user?.risk_score >= 500) {
          riskKey = "fair";
        } else if (user?.risk_score >= 350) {
          riskKey = "poor";
        } else {
          riskKey = "critical";
        }

        const userColor = COLOR_MAP?.[riskKey] || "#ef4444";

        const initials = (user?.name || "Unknown")
          .split(" ")
          .map((n) => n[0])
          .join("")
          .toUpperCase();

        return (
          <div
            key={user?.email || index}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#f9f9f9",
              padding: "15px",
              marginTop: 16,
              borderRadius: 8,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
              }}
            >
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  backgroundColor: `${userColor}20`,
                  color: userColor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: 18,
                  userSelect: "none",
                }}
              >
                {initials}
              </div>

              <div>
                <strong style={{ fontSize: 16 }}>
                  {user?.name || "Unknown User"}
                </strong>

                <div
                  style={{
                    fontSize: 14,
                    color: "#666",
                  }}
                >
                  {user?.email}
                </div>

                <div
                  style={{
                    marginTop: 6,
                    display: "inline-block",
                    backgroundColor: "#eee",
                    color: "#444",
                    padding: "2px 8px",
                    borderRadius: 12,
                    fontSize: 12,
                    fontWeight: "600",
                    userSelect: "none",
                  }}
                >
                  {user?.department || "Unassigned"}
                </div>
              </div>
            </div>

            <div
              style={{
                textAlign: "right",
                minWidth: 70,
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: 20,
                  color: userColor,
                  userSelect: "none",
                }}
              >
                {user?.risk_score ?? 0}
              </div>

              <div
                style={{
                  fontSize: 12,
                  color: "#7d7d7d",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: 4,
                }}
              >
                Risk Score

                {/* <Tooltip
                  title="Your Risk Score starts at 1000 and decreases when you click phishing links or submit sensitive information during phishing simulations. A higher score indicates better security awareness."
                  color="#fff"
                  overlayInnerStyle={{
                    color: "#000",
                    maxWidth: "200px",
                  }}
                >
                  <InfoCircleOutlined
                    style={{
                      color: "#999",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip> */}
              </div>
            </div>
          </div>
        );
      })}
      <Pagination
        current={currentPage}
        total={totalRecords}
        pageSize={5}
        showSizeChanger={false}
        onChange={onPageChange}
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "flex-end",
        }}
      />
    </>
  );
};

export default TotalAssessedUsers;